import React from 'react';
import PropTypes from 'prop-types';
import Async from '../../../core/layout/Async';

const KpiSummary = (props) => (
  <div style={{ marginTop: 20 }}>
    <Async fetching={props.isLoading} size="sm">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          textAlign: 'center',
        }}
      >
        <span style={{ fontWeight: 'bold' }}>{props.title}</span>
        <div style={{ marginTop: 12 }}>
          <span>{props.formatter(props.currentValue)}</span>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontSize: 12, marginTop: 8, marginBottom: -3 }}>Previous</span>
            <span style={{ fontSize: 12 }}>{props.formatter(props.previousValue)}</span>
          </div>
          {props.standardDeviationValue !== null && (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: 12, marginTop: 8, marginBottom: -3 }}>Standard Deviation</span>
              <span style={{ fontSize: 12 }}>{props.formatter(props.standardDeviationValue)}</span>
            </div>
          )}
        </div>
      </div>
    </Async>
  </div>
);

KpiSummary.propTypes = {
  isLoading: PropTypes.bool,
  currentValue: PropTypes.number.isRequired,
  previousValue: PropTypes.number.isRequired,
  formatter: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  standardDeviation: PropTypes.number,
};

KpiSummary.defaultProps = {
  isLoading: false,
  standardDeviationValue: null,
};

export default KpiSummary;
